/**
 * This is the main entry point for the browserify bundle and handles
 * bootstrapping the clientside. Try to keep it small! :D
 */

/**
 * Dependencies
 */
import React from 'react';
import PropTypes from 'prop-types';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter } from 'react-router-redux';
import { Tracking as nwTracking } from '@nerdwallet/nw-client-lib';
import initBaseStyles from '@nerdwallet/base-styles/init';

// Route Definitions
import routes from './routes';

const history = createHistory();

// Webpack lets us us embed styles and assets within the code.
require('@nerdwallet/base-styles/reset.css');
require('@nerdwallet/base-styles/base.css');
require('./styles/main.less');

initBaseStyles();

export default class Main extends React.Component {
  componentDidMount() {
    const { store } = this.props;
    nwTracking.logPageView(store.getState().routing.path);
  }

  render() {
    return <ConnectedRouter history={history}>{routes}</ConnectedRouter>;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
Main.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
  store: PropTypes.object,
};
